import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { HeaderProgressTracker } from '../../Common/HeaderStepper/HeaderProgressTracker';
import * as Steps from './steps/index';
import { saveSessionEvent } from "../../../session";
import { setSessionStorageItem, getSessionStorageItem, SESSION_STORAGE_PERM_LIFE_INSURANCE_OBJECT_KEY } from '../../../sessionStorage';
import { OneClickProductType } from '../../Common/Constant';
import './PermLifeInsurance.scss';

export default function PermLifeInsurance(props) {

    useEffect(() => { saveSessionEvent() }, [props.location])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const path = props.location ? props.location.pathname.split("/").pop() : null;
    const allFormState = getSessionStorageItem(SESSION_STORAGE_PERM_LIFE_INSURANCE_OBJECT_KEY);

    const prefill = props.location.search && props.location.search.toLowerCase().includes('prefill');

    let newFormState = {
        currentStep: 1,
        pages: {
            retrieveAccount: Steps.RetrieveAccount.DefaultFormState(prefill),
            insuredBasicInfo: Steps.InsuredBasicInfo.DefaultFormState(prefill),
            clientPreferences: Steps.ClientPreferences.DefaultFormState(),
            yourInformation: Steps.YourInformation.DefaultFormState(),
            caseInitiation: Steps.CaseInitiation.DefaultFormState(prefill),
        },
    }
    const initialFormState = allFormState || newFormState;

    const [formState, setFormState] = useState(initialFormState);

    useEffect(() => {

        if (!path) {
            return;
        }

        let nextStep = steps.find((s) => s.path === path);

        if (!nextStep) {
            const newPath = props.location ? props.location.pathname.split("/").slice(-2) : null;
            if (!newPath) {
                return;
            }

            nextStep = steps.find((s) => s.path === newPath[0]);
            if (!nextStep) {
                return;
            }
        }
        const newFormState = { ...formState, currentStep: nextStep.step };
        setFormState(newFormState);
    }, [path]);

    const onNext = () => {
        const nextStep = steps.find((s) => s.step === formState.currentStep + 1);

        if (!nextStep) {
            throw new Error('onNext did not find a next step');
        }

        const newFormState = { ...formState, currentStep: nextStep.step };

        setFormState(newFormState);
        setSessionStorageItem(SESSION_STORAGE_PERM_LIFE_INSURANCE_OBJECT_KEY, newFormState);
        props.history.push(`/Products/Perm/${nextStep.path}`);
        window.scroll(0, 0);
    };

    const onBack = () => {
        const backStep = steps.find(s => s.step === formState.currentStep - 1);

        if (backStep) {
            const newFormState = { ...formState, currentStep: backStep.step };

            setFormState(newFormState);
            setSessionStorageItem(SESSION_STORAGE_PERM_LIFE_INSURANCE_OBJECT_KEY, newFormState);
            props.history.push(`/Products/Perm/${backStep.path}`);
            window.scroll(0, 0);

        }
        else {
            props.history.push('/Products');
        }
    };

    const onFieldChange = (step, field, value) => {
        setFormState({ ...formState, pages: { ...formState.pages, [step]: { ...formState.pages[step], [field]: value } } });
    }

    const calculatePercentage = (totalStep, step, categoryStep, currentCateTotalStep) => {
        let stepPer = ((step - 1) / totalStep * 100);
        let cateCount = currentCateTotalStep === 1 ? 1 : (((categoryStep - 0.5) / currentCateTotalStep) * (100 / totalStep));
        return stepPer + cateCount;
    }

    const setAllFormOnAccountNoChanged = (value = null) => {
        let newFormState = formState;
        const clientData = Steps.RetrieveAccount.DefaultFormState(prefill);
        const insuredData = Steps.InsuredBasicInfo.DefaultFormState(prefill);
        clientData.clientType = value || formState.pages.retrieveAccount.clientType;
        if(!value){
          clientData.officeFa = formState.pages.retrieveAccount.officeFa;
          if(formState.pages.retrieveAccount.clientType === 'Existing'){
            clientData.officeAccount = formState.pages.retrieveAccount.officeAccount;
            clientData.branchOptions = formState.pages.retrieveAccount.branchOptions;
            clientData.faNum = formState.pages.retrieveAccount.faNum;
            clientData.officeNum = formState.pages.retrieveAccount.officeNum;
          }
        }
        newFormState.pages.retrieveAccount = clientData;
        newFormState.pages.insuredBasicInfo = insuredData;
        setFormState({ ...newFormState });
      }

    const clearFormState = () => {
        sessionStorage.removeItem(SESSION_STORAGE_PERM_LIFE_INSURANCE_OBJECT_KEY);
        setFormState(newFormState);
        props.history.push('/Products/Perm/CaseInitiation');
    }

    const steps = [
        {
            step: 1,
            path: 'CaseInitiation',
            progressTitle: 'Basics',
            component: (
                <Steps.CaseInitiation
                    formState={formState.pages.caseInitiation}
                    onFieldChange={(field, value) => onFieldChange('caseInitiation', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    history={props.history}
                />
            ),
            breadCrumbTitle: 'NEW CASE',
            categoryNumber: 1,
            categoryStep: 1
        },
        {
            step: 2,
            path: 'Client',
            progressTitle: 'Basics',
            component: (
                <Steps.RetrieveAccount
                    formState={formState.pages.retrieveAccount}
                    onFieldChange={(field, value) => onFieldChange('retrieveAccount', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    fullFormState={formState}
                    setAllFormOnAccountNoChanged={(value)=>setAllFormOnAccountNoChanged(value)}
                    onMultiFieldChange={(fs) => {
                        setFormState(fs);
                    }}
                    insuredInfoDefaultState = {Steps.InsuredBasicInfo.DefaultFormState(prefill)}
                />
            ),
            breadCrumbTitle: 'NEW CASE',
            categoryNumber: 1,
            categoryStep: 1
        },
        {
            step: 3,
            path: 'BasicInfo',
            progressTitle: 'Basics',
            component: (
                <Steps.InsuredBasicInfo
                    formState={formState.pages.insuredBasicInfo}
                    onFieldChange={(field, value) => onFieldChange('insuredBasicInfo', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    fullFormState={formState}
                    onMultiFieldChange={(fs) => {
                        setFormState(fs);
                    }}
                    ageSpecs={{ min: 0, max: 99 }}
                />
            ),
            breadCrumbTitle: 'NEW CASE',
            categoryNumber: 1,
            categoryStep: 2,
        },
        {
            step: 4,
            path: 'ClientPreferences',
            progressTitle: 'Basics',
            component: (
                <Steps.ClientPreferences
                    formState={formState.pages.clientPreferences}
                    onFieldChange={(field, value) => onFieldChange('clientPreferences', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                />
            ),
            breadCrumbTitle: 'QUOTE',
            categoryNumber: 3,
            categoryStep: 5,
        },
        {
            step: 5,
            path: 'YourInformation',
            progressTitle: 'Basics',
            component: (
                <Steps.YourInformation
                    formState={formState.pages.yourInformation}
                    basicInfo={formState}
                    productType={'REQUEST_ILLUSTRATION'}
                    onFieldChange={(field, value) => onFieldChange('yourInformation', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    onMultiFieldChange={(fs) => {
                        setFormState(fs);
                    }}
                    isPermIllustration={true}
                    oneClickProductType={OneClickProductType.MorganStanleyULR}
                />
            ),
            breadCrumbTitle: 'QUOTE',
            categoryNumber: 4,
            categoryStep: 1,
        },
        {
            step: 6,
            path: 'QuoteSuccess',
            progressTitle: 'Basics',
            component: (
                <Steps.QuoteSuccess
                    yourInformation={formState.pages.yourInformation}
                    clearFormState={clearFormState}
                    isIllustration={true}
                />
            ),
            breadCrumbTitle: 'QUOTE',
            categoryNumber: 4,
            lastStep: true,
        },
    ];

    const currentStepObj = steps.find(s => s.step === formState.currentStep) || steps[0];
    const categories = steps.filter((o) => o.categoryNumber === currentStepObj.categoryNumber);

    const totalCategoriesStep = Math.max.apply(Math, categories.map(function (o) { return o.categoryStep; }))
    const percent = calculatePercentage(4, currentStepObj.categoryNumber, currentStepObj.categoryStep, totalCategoriesStep);

    return (
        <div>
            <Helmet>
                <title>Covr Advisor - {currentStepObj.progressTitle} </title>
            </Helmet>

            <HeaderProgressTracker breadCrumb=" QUOTE" breadcrumbLink = {[{ name: 'PRODUCTS', href: '/Products' }, {name: 'PERM LIFE INSURANCE', href: '/Products/Landing/perm-insurance'}]} hidePadding={false} hidden={currentStepObj.hideMainHeader} hideStepsDropdown={currentStepObj.hideStepsDropdown} currentPage={true} showContainer={false} hideProgressTracker={false} title="Perm Life Insurance" stepName={currentStepObj.progressTitle} step={currentStepObj.categoryNumber} categoryStep={currentStepObj.categoryStep} path={currentStepObj.path} totalSteps={4} whiteBg={currentStepObj.whiteBackground} percent={percent} lastStep={currentStepObj.lastStep} headerProductsText={true}>
                <div className="Perm-Life-Insurance mt-4">
                    {currentStepObj.component}
                </div>
            </HeaderProgressTracker>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/Product/PermLifeInsurance/PermLifeInsurance.js